import React, { useState, useEffect, useRef } from 'react';
import Guide from '../component/Guide';
import { useLocation, useNavigate } from 'react-router-dom';


export default function JoinExp() {
    const navigate = useNavigate();
    const location = useLocation();
    const [step, setStep] = useState(1);
    return (
        <>
            {/* <Guide viewinnerContentIdx={3} viewaccordianStep={2} /> */}
            <div className='join_guide_wrap'>
                {step !== 1 && (<img className='join_guide_header_img' src="./images/rowLogo.svg" />)}


                {step === 1 && (<div className='join_guide_inner_wrap1'>
                    <img className='first_step' src="./images/rowLogo.svg" />
                    <button className='join_guide_btn'
                        onClick={() => setStep(2)}
                    >다음 <img src='./images/icons/chevron-right04.svg' /></button></div>)}
                {step === 2 && (
                    <>
                        <div className='join_guide_inner_wrap2'>
                            <div className='join_guide_content'>
                                <p><span>중.개.업.</span>에 <span>시스템</span>을 입히다. </p>
                                <div>
                                    <p>오직 공인중개사를 위한 업무지원 시스템,</p>
                                    <p>모두의매물 가입을 진심으로 환영합니다.</p>
                                </div>
                            </div>

                            <button className='join_guide_btn'
                                onClick={() => setStep(4)}
                            >다음 <img src='./images/icons/chevron-right04.svg' /></button>
                        </div></>
                )}
                {step === 3 && (
                    <div className='join_guide_inner_wrap3'>
                        <div className='join_guide_content'>
                            <p>모두의매물은 매물·고객 관리부터</p>
                            <p>사무소 운영, 임직원 업무 관리까지</p>
                            <p>중개사님의 <span>모든 업무</span>를 도와드립니다.</p>
                        </div>

                        <button className='join_guide_btn'
                            onClick={() => setStep(4)}
                        >다음 <img src='./images/icons/chevron-right04.svg' /></button>
                    </div>
                )}
                {step === 4 && (
                    <div className='join_guide_inner_wrap4'>
                        <div className='join_guide_content'>
                            <p>언제든지 <span>우측 하단의 <span><img src='./images/icons/circle_purple_q.svg' /></span>아이콘</span>을 클릭하면</p>
                            <p>각 기능들의 이용 가이드를 확인하실 수 있습니다.</p>

                        </div>

                        <button className='join_guide_btn'
                            onClick={() => {
                                //setStep(5)
                                navigate("/Storeselctor", {state: {...location.state}});
                            }}
                        >다음 <img src='./images/icons/chevron-right04.svg' /></button>
                    </div>
                )}
                {step === 5 && (
                    <div className='join_guide_inner_wrap5'>
                        <div className='join_guide_content'>
                            <p>지금까지와 차원이 다른</p>
                            <p><span>새로운 중개업</span>을 경험해보세요</p>

                        </div>

                        <button className='join_guide_btn' onClick={() => {
                            // navigate('/Register0');
                            // console.log(location.state)
                            // return;
                            navigate("/Storeselctor", {state: {...location.state}});
                        }}
                        >다음 <img src='./images/icons/chevron-right04.svg' /></button>
                    </div>
                )}

            </div>
        </>

    )
}